module.exports = __webpack_public_path__ + "static/img/SMS.d2b5f8cc.jpg";